import { render, staticRenderFns } from "./KnInterfaceColorThemeEditor.vue?vue&type=template&id=3e0e4197&scoped=true"
import script from "./KnInterfaceColorThemeEditor.js?vue&type=script&lang=js&external"
export * from "./KnInterfaceColorThemeEditor.js?vue&type=script&lang=js&external"
import style0 from "./KnInterfaceColorThemeEditor.vue?vue&type=style&index=0&id=3e0e4197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0e4197",
  null
  
)

export default component.exports